import RemoteCollection from "#root/utility/remote-collection";
import * as z from "zod";

export const VendorListItemSchema = z.object({
  id: z.number(),
  name: z.string().nullish(),
  account_name: z.string().nullish(),
});

export const VendorDetailItemSchema = VendorListItemSchema.extend({
  accountId: z.number().nullish(),
  website: z.string().nullish(),
  group: z.string().nullish(),
  image: z.string().nullish(),
  profile: z.string().nullish(),
}).loose();

export type VendorListItem = z.output<typeof VendorListItemSchema>;
export type VendorDetailItem = z.output<typeof VendorDetailItemSchema>;

export const vendorCollection = new RemoteCollection("/api/vendor", VendorListItemSchema, VendorDetailItemSchema);

export const VendorLogoListItemSchema = z.object({
  website: z.string().nullish(),
  image: z.string().nullish(),
});

export type VendorLogoListItem = z.output<typeof VendorLogoListItemSchema>;

export function getVendorLogoCollectionByGroup(group: string) {
  return new RemoteCollection(`/api/vendor/byGroup/${group}/logos`, VendorLogoListItemSchema);
}
